import './App.css';
import Header from './Header';
import MainBlock from './MainBlock';

function App() {
  return (
    <>
    <Header/>
    <MainBlock/>
    </>
  );
}

export default App;
